import midasInstance from '@rsos/midas/src/midasInstance';
import { formatInternationalPhoneNumberE164 } from './internationalPhoneNumberUtils';

export const postRoadsideAssistanceLink = async (
  phoneNumber = '',
  accountId = '',
): Promise<string> => {
  const phone = formatInternationalPhoneNumberE164(phoneNumber);

  if (!phone) {
    throw new Error(`Invalid phone number: ${phoneNumber}`);
  }

  const response = await midasInstance.post(
    '/internal_auth/trigger',
    {
      callflow: '/agero/swooplink',
      blocking: true,
      variables: {
        phone,
        ecc_id: accountId,
      },
    },
    { headers: { retry: true } },
  );

  if (!response.data?.detail) {
    throw new Error('Roadside Assistance Request Failed: no link returned');
  }

  return response.data.detail;
};
